// import { useEffect, useState } from "react";
// import { Card, Spin, Row, Col, Empty, Button, message } from "antd";
// import { Link } from "react-router-dom";
// import api from "../api/axiosClient";
// import { categoryRouteMap } from "../utils/categoryRouteMap";
// import CompletedTask from "./CompletedTask";

// const MyTask = ({user,todayTaskCount,setTodayTaskCount,
// }) => {
//  // console.log("user in MyTask" , user);
//   const [tasks, setTasks] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // 🔹 Fetch today's tasks
//   const fetchTasks = async () => {
//     try {
//       if(user.role === "Student")
//       {
//         const res = await api.get("/users/todaytaskstudent");
//       setTasks(res.data);
//     console.log(res.data)
//       setTodayTaskCount((res.data).length)
//         }
      
//         else{
//       const res = await api.get("/users/todaytask");
//       setTasks(res.data);
       
//        setTodayTaskCount((res.data).length)
//         }
//     } catch (err) {
//       message.error("Failed to load tasks");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTasks();
//   }, []);

//   if (loading) return <Spin size="large" />;
//  // if (!tasks.length) return <Empty description="No tasks available" />;

//   return (

//     <div style={{  minHeight: "100vh", 
//        // display: "flex", 
//         background: "linear-gradient(135deg, #ffd194, #6a11cb)", 
//         padding: 20 }}>
//           {/* <Row><button style={{backgroundColor:" #a0d8e5",padding:15,borderRadius:0}}></button></Row> */}
//     <Row gutter={[16, 16]}>
//       {tasks.map((task) => (
//         <Col xs={24} md={12} lg={8} key={task.userTaskId}>
//           <Card
//             title={task.title}
//             extra={
//               <span style={{ color: "green", fontWeight: "bold" }}>
//                 Active
//               </span>
              
//             }
//           >
//              {task.description && (
//                 <p>
//                   <strong>Description:</strong> {task.description}
//                 </p>
//               )}
//               {<br></br>}
//             {task.categories.map((cat) =>
//               cat.levels.map((lvl) => {
//                 const route = categoryRouteMap[cat.name];

//                 return (
//                   <div
//                     key={`${cat.name}-${lvl.selectedLevel}`}
//                     style={{ marginBottom: 12,textAlign:"center" ,}}
//                   >
                  

//                     {route ? (
//                       <Link
//                         to={`${route}?selectedLevel=${lvl.selectedLevel}&userTaskId=${task.userTaskId}&category=${encodeURIComponent(
//                           cat.name
//                         )}`}
//                       >
//                         <Button  style={{textAlign:"center", background: "#ffbf00",
//                     color: "#4d3300",padding:10,fontSize:20,
//                       borderRadius:15,width:180}} type="primary" size="small">
//                           <p style={{textAlign:"center", background: "#ffbf00",
//                     color: "#4d3300",padding:10,fontSize:20,
//                       borderRadius:15,width:280}}>
//                      <strong>  {cat.name}<br></br>
                    
//                      Level: {lvl.selectedLevel}</strong>
//                     </p>
//                         </Button>
//                       </Link>
//                     ) : (
//                       <p style={{ color: "red" }}>
//                         Route not found for this category
//                       </p>
//                     )}
//                   </div>
//                 );
//               })
//             )}
//           </Card>
//         </Col>
//       ))}
//     </Row>


//     <CompletedTask 
//     user={user} 
    
//     />
  
//     </div>
//   );
// };

// export default MyTask;
import { useEffect, useState } from "react";
import {
  Card,
  Spin,
  Row,
  Col,
  Empty,
  Button,
  message,
} from "antd";
import { Link } from "react-router-dom";
import api from "../api/axiosClient";
import { categoryRouteMap } from "../utils/categoryRouteMap";
import CompletedTask from "./CompletedTask";

const MyTask = ({
  user,
  todayTaskCount,
  setTodayTaskCount,
}) => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTasks = async () => {
    if (!user) return;

    try {
      setLoading(true);

      const endpoint =
        user.role === "Student"
          ? "/users/todaytaskstudent"
          : "/users/todaytask";

      const res = await api.get(endpoint);
console.log(res.data)
      setTasks(res.data);
      setTodayTaskCount(res.data.length);
    } catch (err) {
      console.error(err);
      message.error("Failed to load tasks");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTasks();
  }, [user]);

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #ffd194, #6a11cb)",
        padding: 20,
      }}
    >
      {tasks.length === 0 ? (
        <Empty
          description="No tasks available today"
          style={{ marginTop: 80 }}
        />
      ) : (
        <Row gutter={[16, 16]}>
          {tasks.map((task) => (
            <Col xs={24} md={12} lg={8} key={task.userTaskId}>
              <Card
                title={task.title}
                extra={
                  <span
                    style={{
                      color: "green",
                      fontWeight: "bold",
                    }}
                  >
                    Active
                  </span>
                }
              >
                {task.description && (
                  <p>
                    <strong>Description:</strong> {task.description}
                  </p>
                )}

                {task.categories?.map((cat) =>
                  cat.levels?.map((lvl) => {
                    const route = categoryRouteMap[cat.name];

                    return (
                      <div
                        key={`${task.userTaskId}-${cat.name}-${lvl.selectedLevel}`}
                        style={{
                          marginBottom: 15,
                          textAlign: "center",
                        }}
                      >
                        {route ? (
     <Link
    // to={`${route}?selectedLevel=${lvl.selectedLevel}&userTaskId=${task.userTaskId}&category=${encodeURIComponent(
    //                           cat.name
    //                         )}`}

    to={`${route}
?level=${task.level}
&selectedLevel=${lvl.selectedLevel}
&userTaskId=${task.userTaskId}
&category=${encodeURIComponent(cat.name)}`}
                          >
                            <Button
                              type="primary"
                              style={{
                                background: "#ffbf00",
                                color: "#4d3300",
                                borderRadius: 15,
                                width: 220,
                                height: "auto",
                                padding: "14px",
                                whiteSpace: "normal",
                                fontSize: 18,
                                fontWeight: "bold",
                              }}
                            >
                              {cat.name}
                              <br />
                              Level: {lvl.selectedLevel}
                            </Button>
                          </Link>
                        ) : (
                          <p style={{ color: "red" }}>
                            Route not found for "{cat.name}"
                          </p>
                        )}
                      </div>
                    );
                  })
                )}
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <div style={{ marginTop: 30 }}>
        <CompletedTask user={user} />
      </div>
    </div>
  );
};

export default MyTask;